const binding = { modules: {}, dataActions: {} };

    (binding.modules['richtext'] = {
        c: () => require('partner/modules/richtext/richtext.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'richtext',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/richtext'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|richtext|richtext'] = {
                c: () => require('partner/modules/richtext/richtext.view.tsx'),
                cn: '__local__-__local__-richtext'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };